import React, { useState, useEffect } from "react";
import {
  getCustomerMasterlist,
  saveCustomerDetails,
  updateCustomerDetails,
} from "../../../../apiservicescall/api";

import Table from "@mui/material/Table";
import { Link } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Col, Badge, Card, Row, Button, Container } from "react-bootstrap";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { Form, FormGroup, Label, Input } from "reactstrap";
import swal from "sweetalert";

const CustomerStaffManagment = () => {
  const [customerList, setCustomerList] = useState([]);
  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [largeModal, setLargeModal] = useState(false);

  const [customerDetail, setCustomerDetail] = useState({
    firstName: "",
    emailId: "",
    custMobile: "",
    address1: "",
    address2: "",
    address3: "",
    alterMobile: "",
    category: "",
    city: "",
    country: "",
    custAddressId: "",
    custMasterId: "",

    delPoint: "",
    geoAddress: "",
    geoLocation: "",
    pincode: "",
    state: "",
    status: "",
    // adresMaster: "",
    // alterMobile: " ",
    //category: " ",
    // city: " ",
    // country: " ",
    // custAddressId: " ",
    custId: "",
    // custMobile: " ",
    geoAddress: "",
    geoLocation: "",
    pincode: "",
    state: "",
  });

  let [editCall, setEditCall] = useState(false);

  // const [editcustomerobj, setEditCustomerobj] = useState({});
  let [formIsValid, setFormIsValid] = useState(false);
  let [errors, setErrors] = useState({
    custName: null,
    emailId: null,
    custMobile: null,
    address1: null,
    address2: null,
    address3: null,
    city: null,
    country: null,
    state: null,
    pincode: null,
  });
  // const [userDetails, setUserDetails] = useState(
  //   JSON.parse(localStorage.getItem("userDetails"))
  // );

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    getcustomerlist();
  }, []);

  const getcustomerlist = async () => {
    let customerList = await getCustomerMasterlist();

    let customerlistvalue = customerList?.data.data || [];
    setCustomerList(customerlistvalue);

    let totpage = Math.ceil(customerlistvalue.length / itemsPerPage);

    setTotalPages(totpage);

    let titem = customerlistvalue.length;
    setTotalItems(titem);
  };

  const saveupdatecustomer = async () => {
    let data = {
      custName: customerDetail.firstName || " ",
      custMobile: customerDetail.custMobile || " ",
      city: customerDetail.city || " ",
      address1: customerDetail.address1 || " ",
      address2: customerDetail.address2 || "",
      address3: customerDetail.address3 || "",
      alterMobile: customerDetail.alterMobile || "",
      category: customerDetail.category || "",
      country: customerDetail.country || "",
      custAddressId: customerDetail.custAddressId || 0,
      custId: customerDetail.custId || 0,
      geoAddress: customerDetail.geoAddress || "",
      geoLocation: customerDetail.geoLocation || " ",
      pincode: customerDetail.pincode || " ",
      state: customerDetail.state || " ",
    };

    // let formData = new FormData();

    let reqforupload;

    if (!isedit) {
      reqforupload = await saveCustomerDetails(data);
    } else {
      reqforupload = await updateCustomerDetails(data);
    }

   
    if (reqforupload?.status === 200) {
      setCustomerDetail({});
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
      if (!isedit) {
        swal("Success!", "Customer Added", "success");
      } else {
        swal("Success!", "Customer Updated", "success");
      }
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
    }
  };

  const opnAddNewUserModal = (e) => {
    e.preventDefault();
    setLargeModal(!largeModal);
    setIsview(false);
    setIsedit(false);
  };

  const onEditUser = (data) => {
    let selectedCustomer = customerList.find(
      (value, index) => index === data?.rowIndex
    );

    

    setCustomerDetail({
      // ...customerDetail,
      // ...selectedCustomer,
      custName: selectedCustomer.firstName || " ",
      custMobile: selectedCustomer.custMobile || " ",
      emailId: selectedCustomer.emailId || " ",
      //adresMaster: selectedCustomer.address1,

      address1: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].address1
        : " ",
      address2: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].address2
        : " ",
      address3: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].address3
        : " ",
      alterMobile: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].alterMobile
        : " ",
      category: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].category
        : " ",
      city: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].city
        : " ",
      country: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].country
        : " ",
      custAddressId: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].custAddressId
        : " ",
      delPoint: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].delPoint
        : " ",
      geoAddress: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].geoAddress
        : " ",
      geoLocation: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].geoLocation
        : " ",
      pincode: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].pincode
        : " ",
      state: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].state
        : " ",
      status: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].status
        : " ",
    });
   

    setEditCall(true);

    setLargeModal(true);
    setIsedit(true);
    setIsview(false);
    setErrors({});
    setFormIsValid(true);
  };

  const viewUser = (data) => {
    let selectedCustomer = customerList.find(
      (value, index) => index === data?.rowIndex
    );
   

    setCustomerDetail({
      //  ...customerDetail,
      //  ...selectedCustomer
      custName: selectedCustomer.firstName || " ",
      custMobile: selectedCustomer.custMobile || " ",
      city: selectedCustomer.city || " ",
      emailId: selectedCustomer.emailId || " ",
      address1: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].address1
        : " ",
      address2: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].address2
        : " ",
      address3: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].address3
        : " ",
      alterMobile: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].alterMobile
        : " ",
      category: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].category
        : " ",
      city: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].city
        : " ",
      country: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].country
        : " ",
      custAddressId: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].custAddressId
        : " ",
      delPoint: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].delPoint
        : " ",
      geoAddress: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].geoAddress
        : " ",
      geoLocation: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].geoLocation
        : " ",
      pincode: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].pincode
        : " ",
      state: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].state
        : " ",
      status: selectedCustomer.omsCustomerMasterAddress[0]
        ? selectedCustomer.omsCustomerMasterAddress[0].status
        : " ",
    });
    //

    setLargeModal(true);
    setIsview(true);
    setIsedit(false);
    setErrors({});
    setFormIsValid(true);

  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };

  const onChangeCommonpopup = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;
    const stringPattern = /^[-a-zA-Z-()]+(\s+[-a-zA-Z()]+)*$/;
    const emailPattern =
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;
    const mobilePattern = /^[5-9][0-9]{9}$/;
    const addressPattern =
      /^[-a-zA-Z0-9_@./#&%*,.+-//]+(\s+[-a-zA-Z0-9_@./#&,%*.+-//]+)*$/;
    const pincodePattern = /^[1-9][0-9]{5}$/;

    if (key == "firstName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["firstName"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["firstName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["firstName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "emailId") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["emailId"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!emailPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["emailId"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["emailId"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "custMobile") {
      if (value.length > 10) {
        return false;
      } else if (!mobilePattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["custMobile"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["custMobile"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "address1") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["address1"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!addressPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["address1"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["address1"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "address2") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["address2"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!addressPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["address2"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["address2"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "address3") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["address3"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!addressPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["address3"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["address3"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "city") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["city"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["city"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["city"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "state") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["state"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["state"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["state"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "country") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["country"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["country"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["country"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "pincode") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["pincode"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!pincodePattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["pincode"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["pincode"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    const newFormData = { ...customerDetail };
    newFormData[key] = value;
    
    setCustomerDetail(newFormData);
  };

  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        
        return (
          <div className="list-action">
            <span style={{ color: "white",display:"flex" }} className="icon-top-left">
              {/* <button
                type="button"
                className="rct-link-btn edit-btn"
                onClick={() => onEditUser(tableMeta)}
              >
                <i style={{ fontSize: "15px" }} className="ti-pencil"></i>
              </button> */}

              <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  onEditUser(tableMeta);
                }}
                // style={{ background: "#008000" }}
              >
                <i className="fas fa-pencil-alt fa-lg tpen-bck" style={{display:"flex",alignItems:"center",marginLeft:"1px"}}></i>
              </Link>

              <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  viewUser(tableMeta);
                }}
                // style={{ background: "#008000" }}
              >
                <i className="fa fa-eye tpen-bck" style={{marginLeft:"3px"}}></i>
              </Link>
            </span>

            {/* <span style={{ paddingLeft: "20px",marginTop: "-20px" }} className="icon-top-left">

              <Link className="btn btn-primary shadow btn-xs sharp me-2"
                onClick={() => viewUser(tableMeta)} style={{ background: "#008000" }}
              >
                <i className="fa fa-eye"></i>
              </Link>
            </span> */}
          </div>
        );
      },
    },
  };

  const options = {
    filter: true, 
      search: true, 
      selectableRows: false,
      responsive: "stacked",
      fixedHeader: true,
      tableBodyHeight: "60vh",
      fixedSelectColumn: true,
      page: currentPage,
      pagination: true,
      serverSide: false,
      rowsPerPage: itemsPerPage,
      rowsPerPageOptions: [10, 15, 100],
      onChangePage: (newPage) => {
        handleChangePage(newPage);
      },
      onChangeRowsPerPage: (numOfRows) => {
        onChangeRowsPerPage(numOfRows);
      },
      download: false,
      print: false,
      onFilterChange: (column, filterList, type, filterOptions, changedColumnIndex) => {
        
      },
      confirmFilters: true,
      customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
        return (
          <div style={{ marginTop: "40px" }}>
            <Button
              variant="contained"
              onClick={() => applyNewFilters()} 
            >
              Apply Filters
            </Button>
          </div>
        );
      },
      onFilterConfirm: (filterList) => {
        // Handle filter confirmation here if needed
      },
      onFilterDialogOpen: () => {
        // Handle filter dialog open event if needed
      },
      onFilterDialogClose: () => {
        // Handle filter dialog close event if needed
      },
    customToolbar: () => {
      return (
        <>
          {
            <>
              {largeModal ? (
                <a
                  href="#"
                  style={{ backgroundColor: "#008000", color: "white" }}
                  onClick={(e) => opnAddNewUserModal(e)}
                  className="caret btn-sm mr-10"
                >
                  ADD <i className="zmdi zmdi-lus"></i>
                </a>
              ) : (
                <a
                  href="#"
                  style={{
                    backgroundColor: "#008000",
                    color: "white",
                    fontSize: "medium",
                  }}
                  onClick={(e) => {
                    opnAddNewUserModal(e);
                    setCustomerDetail({});
                  }}
                  className="caret btn-sm mr-10"
                >
                  Add <i className="zmdi zmdi-lus"></i>
                </a>
              )}
            </>
          }
        </>
      );
    },
    //Search Query for list

    // customSearchRender: (searchText, handleSearch, hideSearch, options) => {
    //  
    //   return (
    // 	<>
    // 	  <CustomSearchRender
    // 		debounceWait={500}
    // 		searchText={searchText}
    // 		onSearch={this.handleSearch}
    // 		onHide={hideSearch}
    // 		options={options}
    // 		onClear={this.handleClear}
    // 		searchField={this.state.searchField}
    // 		searchValue={this.state.searchValue}
    // 		fields={this.state.fields}
    // 		handleFieldChange={this.handleFieldChange}
    // 	  />
    // 	</>
    //   );
    // },
  };
 
  const columns = [
    {
      name: "firstName",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "custMobile",
      label: "Mobile ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "emailId",
      label: "Email ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    // {
    //   name: "alterMobile",
    //   label: "AlterMobile",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     customFilterListOptions: { render: (v) => `UID: ${v}` },
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",
    //   },
    // },

    // {
    //   name: "delPoint",
    //   label: "Point",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     customFilterListOptions: { render: (v) => `UID: ${v}` },
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",
    //   },
    // },

    {
      name: "omsCustomerMasterAddress",
      label: "Customer Address",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customBodyRender: (
          omsCustomerMasterAddress,
          tableMeta,
          updateValue
        ) => {
          return omsCustomerMasterAddress.map((address) => {
            return (
              <>
                {" "}
                <span
                  className="badge badge-success"
                  style={{ color: "black" }}
                >
                  {address.address2}
                </span>
              </>
            );
          });
        },
      },
    },

    //   {
    //     name: "firstLoginStatus",
    //     label: "firstLoginStatus",
    //     options: {
    //       filter: false,
    //       sort: true,
    //       customFilterListOptions: { render: (v) => `UID: ${v}` },
    //       fixedHeader: true,
    //       responsive: "stacked",
    //       filterType: "textField",
    //     },
    //  },

    actionOption,
  ];

  //   // let activeStatus = selectedUser.activeStatus == "A" ? true : false;

  //   setEditOutletobj({
  //     ...outletDetails,
  //     ...selectedUser,
  //     ...(selectedUser.activeStatus == "A" ? false : true),
  //   });
  //   setEditCall(true);

  //   // const tempstatemaster = bankMaster
  //   //   .filter((item) => item.value == selectedUser.outletBankName)
  //   //   .map(({ value, label }) => ({ value: value, label: label }));
  //  
  //   // setOutletBankNameValue(tempstatemaster);

  //   setLargeModal(true);
  //   setIsview(true);
  //   setIsedit(false);
  //   setErrors({});
  //   setFormIsValid(true);
  //  
  // };

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  return (
    <>
      {!largeModal ? (
        <RctCollapsibleCard fullBlock>
          <RctCollapsibleCard fullBlock>
            <MuiThemeProvider theme={themeTable}>
              {customerList && (
                <MUIDataTable
                  title={"Customer Master List"}
                  data={customerList}
                  columns={columns}
                  options={options}
                  columOrder={columns}
                  className={"MuiTabCusCls"}
                />
              )}
            </MuiThemeProvider>
          </RctCollapsibleCard>
        </RctCollapsibleCard>
      ) : (
        <>
          <RctCollapsibleCard fullBlock>
            <RctCollapsibleCard fullBlock>
              <div className="mb-sm-4 d-flex flex-wrap align-items-center text-head ovrl-crd-hd">
                <h3 className="ms-3 mt-1 me-auto" style={{ fontFamily: "Roboto" }}>
                  Create New
                </h3>
                {largeModal && (
                  <button
                    className="btn btn-primary btn-rounded me-3 mb-2 stf-crt-btn"
                    style={{ backgroundColor: "#008000" }}
                    onClick={() => {
                      setLargeModal(!largeModal);
                      setIsedit(false);
                      setIsview(false);
                      setErrors({});
                    }}
                  >
                    {" "}
                    Back{" "}
                  </button>
                )}
              </div>

              {/* <Stepper
                alternativeLabel
                nonLinear
                className="stepper-rtl"
                activeStep={activeStep}
              >
                {steps.map((step, index) => {
                  const labelProps = {};
                  const stepProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography
                        variant="caption"
                        align="center"
                        style={{ display: "block" }}
                      >
                        optional
                      </Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={step} {...props}>
                      <StepButton
                        onClick={() => handleStep(index)}
                        {...stepProps}
                      >
                        {step}
                      </StepButton>
                    </Step>
                  );
                })}
              </Stepper> */}
              {/*  <div className="pl-40">
                <p>{getStepContent(activeStep)}</p>
              </div> */}

              <div className="row">
                <Col xl="6">
                  <Card>
                    <Card.Header className="text-white bg-secondary">
                      <Card.Title style={{ color: "white" }}>
                        Customer Details
                      </Card.Title>
                      {/* <i
                        className="fas fa-redo"
                        onClick={() => {
                         
                          saveupdateoutlet();
                        }} 
                      ></i> */}
                    </Card.Header>
                    <Card.Body className="mb-0 bg-green-light">
                      <Card.Text style={{ fontSize: "medium" }}>
                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Name
                            <span class="text-warning">*</span>
                          </label>
                          <br />

                          <Input
                            type="text"
                            name="firstName"
                            id="firstName"
                            placeholder="Name"
                            maxLength="20"
                            value={customerDetail?.firstName}
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) => {
                              onChangeCommonpopup("firstName", e.target.value);
                            }}
                            disabled={isView}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["firstName"]}
                          </span>
                        </div>

                        <div class="col-sm form-group">
                          <label
                            as="d"
                            variant="badge badge-rounded badge-danger"
                          >
                            {" "}
                            Email
                            <span class="text-warning">*</span>
                          </label>
                          <br />
                          <Input
                            type="email"
                            name="EmailId"
                            id="EmailId"
                            placeholder="Enter Email"
                            maxLength="30"
                            value={customerDetail?.emailId}
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) => {
                              onChangeCommonpopup("emailId", e.target.value);
                            }}
                            disabled={isView}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["emailId"]}
                          </span>
                        </div>

                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Mobile
                            <span class="text-warning">*</span>
                          </label>
                          <br />
                          <Input
                            type="text"
                            name="mobileNumber"
                            id="mobileNumber"
                            placeholder="Mobile"
                            maxLength="20"
                            value={customerDetail?.custMobile}
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) => {
                              onChangeCommonpopup("custMobile", e.target.value);
                            }}
                            disabled={isView}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["custMobile"]}
                          </span>
                        </div>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xl="6">
                  <Card>
                    <Card.Header className="text-white bg-secondary">
                      <Card.Title style={{ color: "white" }}>
                        Address
                      </Card.Title>
                    </Card.Header>
                    <Card.Body className="mb-0 bg-green-light">
                      <Card.Text style={{ fontSize: "medium" }}>
                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Address 1{/* <span class="text-warning"></span> */}
                          </label>
                          <br />

                          <Input
                            type="textarea"
                            name="Address1"
                            id="Address1"
                            placeholder="Address 1"
                            maxLength="150"
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) => {
                              onChangeCommonpopup("address1", e.target.value);
                            }}
                            disabled={isView}
                            value={customerDetail.address1}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["address1"]}
                          </span>
                        </div>

                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Address 2{/* <span class="text-warning"></span> */}
                          </label>
                          <br />
                          <Input
                            type="textarea"
                            name="Address2"
                            id="Address2"
                            placeholder="Address 2"
                            maxLength="150"
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) => {
                              onChangeCommonpopup("address2", e.target.value);
                            }}
                            disabled={isView}
                            value={customerDetail.address2}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["address2"]}
                          </span>
                        </div>

                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Address 3{/* <span class="text-warning"></span> */}
                          </label>
                          <br />
                          <Input
                            type="textarea"
                            name="Address3"
                            id="Address3"
                            placeholder="Address 3"
                            maxLength="150"
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) =>
                              onChangeCommonpopup("address3", e.target.value)
                            }
                            disabled={isView}
                            value={customerDetail.address3}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["address3"]}
                          </span>
                        </div>

                        <div className="row">
                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="City"> City</label>
                            <Input
                              type="text"
                              name="city"
                              id="city"
                              placeholder="city"
                              maxLength="100"
                              disabled={isView}
                              value={customerDetail.city}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) => {
                                onChangeCommonpopup("city", e.target.value);
                              }}
                            />

                            <span style={{ color: "red" }}>
                              {errors["city"]}
                            </span>
                          </div>

                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="pincode"> State</label>
                            <Input
                              type="text"
                              name="state"
                              id="state"
                              placeholder="state"
                              maxLength="100"
                              disabled={isView}
                              value={customerDetail.state}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) =>
                                onChangeCommonpopup("state", e.target.value)
                              }
                            />

                            <span style={{ color: "red" }}>
                              {errors["state"]}
                            </span>
                          </div>
                        </div>

                        <div className="row">
                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="Country"> Country</label>
                            <Input
                              type="text"
                              name="country"
                              id="country"
                              placeholder="country"
                              maxLength="50"
                              disabled={isView}
                              value={customerDetail.country}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) =>
                                onChangeCommonpopup("country", e.target.value)
                              }
                            />

                            <span style={{ color: "red" }}>
                              {errors["country"]}
                            </span>
                          </div>

                          <div class="col-sm-6 col-md-6 col-xl-6 ">
                            <label for="pincode"> Pincode</label>
                            <Input
                              type="text"
                              name="pincode"
                              id="pincode"
                              placeholder="pincode"
                              maxLength="100"
                              disabled={isView}
                              value={customerDetail.pincode}
                              required
                              style={{ backgroundColor: isView && "#e9ecef" }}
                              onChange={(e) =>
                                onChangeCommonpopup("pincode", e.target.value)
                              }
                            />
                            <span style={{ color: "red" }}>
                              {errors["pincode"]}
                            </span>
                          </div>
                        </div>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

                <div class="text-right">
                  {/* <div class="col-sm-3 col-md-6 col-lg-4"> */}
                  {/* <div > */}
                  <Button
                    variant="contained"
                    className="btn-danger"
                    style={{ marginRight: "40px" }}
                    onClick={() => {
                      setCustomerDetail({
                        firstName: "",
                        emailId: "",
                        custMobile: "",
                        address1: "",
                        address2: "",
                        address3: "",
                        alterMobile: "",
                        category: "",
                        city: "",
                        country: "",
                        custAddressId: "",
                        custMasterId: "",
                        pincode: "",
                        state: "",
                      });
                    }}
                  >
                    Clear
                  </Button>
                  {/* </div>
                  </div> */}

                  {/* <div class="col-sm-9 col-md-6 col-lg-8">
                    <div style={{ paddingLeft: "500px" }}> */}
                  {!isView && !isedit && (
                    <Button
                      variant="contained"
                      // className="btn-info text-white me-3"
                      disabled={!formIsValid}
                      style={{
                        backgroundColor: "#008000",
                        marginRight: "40px",
                      }}
                      className={
                        !formIsValid
                          ? "btn-disabled"
                          : "btn-info text-white me-3"
                      }
                      onClick={() => {
                       
                        saveupdatecustomer();
                      }}
                    >
                      Save
                    </Button>
                  )}
                  {isedit && (
                    <Button
                      variant="contained"
                      //className="btn-success text-white me-3"
                      disabled={!formIsValid}
                      style={{ backgroundColor: "#008000" }}
                      className={
                        !formIsValid
                          ? "btn-disabled"
                          : "btn-info text-white me-3"
                      }
                      onClick={() => {
                        saveupdatecustomer();
                      }}
                    >
                      Update
                    </Button>
                  )}
                  {/* </div>
                  </div> */}
                </div>
              </div>
            </RctCollapsibleCard>
          </RctCollapsibleCard>
        </>
      )}
    </>
  );
};

export default CustomerStaffManagment;
